import { InsurersCodeEnum } from '../enums/insurers-code.enum';

const ORIGIN_LABELS: Record<string, string> = {
  insurer_api: 'Carta da seguradora',
  internal_manual: 'Enviado manualmente',
  internal_generated: 'Gerado pela plataforma',
};

const DOC_TYPE_LABELS: Record<string, string> = {
  approval_letter: 'Carta de aprovação',
  rejection_letter: 'Carta de recusa',
  quote_pdf: 'Cotação (PDF)',
  other: 'Outro documento',
};

const STATUS_LABELS: Record<string, string> = {
  approved: 'Aprovado',
  rejected: 'Recusado',
  pending: 'Pendente',
  unknown: 'Indefinido',
};

const INSURER_LABELS: Partial<Record<InsurersCodeEnum, string>> = {
  [InsurersCodeEnum.Pottencial]: 'Pottencial',
  [InsurersCodeEnum.PortoEssencial]: 'Porto Essencial',
  [InsurersCodeEnum.Too]: 'Too Seguros',
  [InsurersCodeEnum.Porto]: 'Porto',
  [InsurersCodeEnum.Garantti]: 'Garantti',
  [InsurersCodeEnum.TokioMarine]: 'Tokio Marine',
  [InsurersCodeEnum.Creditas]: 'Aluguel em dia - Creditas',
};

export function labelDecisionDocumentOrigin(origin?: string | null): string {
  if (!origin) return 'Origem não informada';
  return ORIGIN_LABELS[origin] ?? origin.replace(/_/g, ' ');
}

export function labelDecisionDocumentType(type?: string | null): string {
  if (!type) return '—';
  return DOC_TYPE_LABELS[type] ?? type.replace(/_/g, ' ');
}

export function labelDecisionDocumentStatus(status?: string | null): string {
  if (!status) return '—';
  return STATUS_LABELS[status] ?? status;
}

export function labelInsurerCodeForDecision(code?: string | null): string {
  if (!code) return 'Não vinculado à seguradora';
  const asEnum = code as InsurersCodeEnum;
  return INSURER_LABELS[asEnum] ?? code.replace(/_/g, ' ');
}
